import {CommonOptionVM} from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class GlobalSectionOptionsVM extends CommonOptionVM {
  global_item_id?: string

  constructor(data: Partial<GlobalSectionOptionsVM> = {}) {
    super(data)
    this.global_item_id = (data as any)?.global_item_id ?? undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default GlobalSectionOptionsVM